import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import DateService from "../../../Services/Shared/Date.service";
const PersonHighSchoolListItem = ({ personHighSchool }) => {
    return (_jsxs("div", { className: "mb-2 form-group", children: [_jsx("label", { children: personHighSchool.highSchool.name }), _jsxs("div", { children: [DateService.display(personHighSchool.startDate), " -", " ", DateService.display(personHighSchool.endDate), _jsx("div", { children: _jsxs("span", { className: "badge badge-primary mr-2", children: ["GPA:", " ", (personHighSchool.gpa && personHighSchool.gpa.toFixed(2)) ||
                                    "Not Found"] }) })] })] }));
};
export default PersonHighSchoolListItem;
